import { ChannelBatchPayload } from '@/types/BatchPayload.interface'
import Channel from '@/types/Channel.interface'

export default {
    state: {},
    mutations: {},
    actions: {
        channelsFind({ commit, getters }, channelId: number): Promise<Channel> {
            //  Assemble the API endpoint
            const url = `${getters.api}/channels/${channelId}`

            //  Send the request
            return window.axios.get(url).then(response => {
                //  Return our channel
                return response.data
            }).catch(() => null)
        },
        channelsPut ({ commit, getters }, channel: Channel): Promise<Channel> {
            //  Assemble the API endpoint
            const url = `${getters.api}/channels`

            //  Send the request
            return window.axios.put(url, channel).then(response => {
                //  Update the inbox
                commit('inboxChannelsSync', [response.data])

                return response.data
            }).catch(() => null)
        },
        channelsPutBatch ({ commit, getters }, channels: ChannelBatchPayload) {
            //  Assemble the API endpoint
            const url = `${getters.api}/channels/batch`

            //  Send the request
            return window.axios.put(url, channels).then(response => {
                //  Update the inbox list
                commit('inboxChannelsSync', response.data.data)

                return response.data
            }).catch((e) => console.error("ChannelsPutBatch ERROR", e))
        },
        channelsWhereIn({ getters }, channel_ids: number[]): Promise<Channel[]> {
            //  Create our payload
            const payload = { 'channel_ids': channel_ids }

            //  Assemble the API endpoint
            const url = `${getters.api}/channels/wherein`

            //  Send the request
            return window.axios.post(url, payload).then(response => {
                return response.data
            }).catch(() => null)
        }
    }
}